export const SUPPORTED_LOCALE_LIST = ["de", "en", "fr"];
export const DEFAULT_LOCALE = "de";
